// tk-announcement-bar e tk-logos caricano entrambi questo file: il secondo
// <script> riesegue il sorgente e una class top-level andrebbe in
// "already declared". Il guard racchiude anche la dichiarazione.
if (!customElements.get('tk-marquee')) {
  class TkMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.tk-marquee__track');
      if (!this.track) return;

      this.mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = this.onMotionChange.bind(this);
      this.mediaQuery.addEventListener('change', this.onMotionChange);

      // Spostare la sezione nell'editor riconnette la stessa istanza col track
      // già popolato di cloni: il set originale va catturato una volta sola,
      // altrimenti raddoppia a ogni reconnect (crescita esponenziale, freeze).
      if (!this.originalSet) {
        this.originalSet = Array.from(this.track.children).map((n) => n.cloneNode(true));
      }
      if (this.originalSet.length === 0) return;

      this.lastViewportWidth = 0;
      this.rafId = null;

      if (this.mediaQuery.matches) {
        return;
      }

      this.setup();

      this.resizeObserver = new ResizeObserver(() => this.scheduleSetup());
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.mediaQuery) this.mediaQuery.removeEventListener('change', this.onMotionChange);
      if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    get speed() {
      const v = parseInt(this.dataset.speed, 10);
      return Number.isFinite(v) && v > 0 ? v : 60;
    }

    scheduleSetup() {
      const w = this.offsetWidth;
      if (Math.abs(w - this.lastViewportWidth) < 2) return;
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = requestAnimationFrame(() => {
        this.rafId = null;
        this.setup();
      });
    }

    onMotionChange() {
      if (this.mediaQuery.matches) {
        this.classList.remove('is-ready');
        this.track.replaceChildren(...this.originalSet.map((n) => n.cloneNode(true)));
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null;
        }
      } else {
        this.setup();
        if (!this.resizeObserver) {
          this.resizeObserver = new ResizeObserver(() => this.scheduleSetup());
          this.resizeObserver.observe(this);
        }
      }
    }

    setup() {
      // Bail early if host has no width (e.g., section inside a hidden tab/drawer).
      // ResizeObserver will re-trigger setup once the host becomes visible.
      if (!this.offsetWidth) return;

      this.track.replaceChildren(...this.originalSet.map((n) => n.cloneNode(true)));
      const originalCount = this.originalSet.length;

      const appendClone = () => {
        this.originalSet.forEach((n) => {
          const clone = n.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, input, select, textarea').forEach((el) => {
            el.setAttribute('tabindex', '-1');
          });
          this.track.appendChild(clone);
        });
      };

      // First clone serves both as filler AND as the measurement anchor for the
      // seamless-loop shift: the offsetLeft of the first cloned item equals
      // (original set width + flex gap) = exactly the distance to translate per loop.
      appendClone();
      const firstCloneItem = this.track.children[originalCount];
      if (!firstCloneItem) return;
      const shiftWidth = firstCloneItem.offsetLeft;
      if (shiftWidth === 0) return;

      const viewportWidth = this.offsetWidth || shiftWidth;
      this.lastViewportWidth = viewportWidth;

      // Keep adding clones until total content >= 2 × viewport (seamless coverage)
      const target = Math.max(viewportWidth * 2, shiftWidth * 2);
      while (this.track.scrollWidth < target) {
        appendClone();
      }

      this.style.setProperty('--tk-marquee-set-width', `${shiftWidth}px`);
      this.style.setProperty('--tk-marquee-duration', `${shiftWidth / this.speed}s`);

      this.classList.add('is-ready');
    }
  }

  customElements.define('tk-marquee', TkMarquee);
}
